import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

import { NzNotificationService } from 'ng-zorro-antd/notification';

import { AuthenticationService, EventService, ValidationService } from '../../../_services';
import { environment } from '../../../../environments/environment';
import {ApiService} from '../../../shared/_services/api.service';

@Component({
    templateUrl: './request.component.html',
    styleUrls: ['../../auth.component.less']
  },
)

export class PasswordRequestComponent implements OnInit, OnDestroy {
  form: UntypedFormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  private unsubscribe$ = new Subject<void>();

  isCaptchaVerified = false;
  env = environment;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthenticationService,
    private api: ApiService,
    private notification: NzNotificationService,
    private eventService: EventService,
    private validationService: ValidationService
  ) {
    // redirect to home if already logged in
    if (this.auth.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      captcha: [null, this.env.captcha ? [Validators.required] : []]
    });

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/auth/login';

    // display api validations on form
    this.eventService.eventEmitted.subscribe(event => {
      if (event.name === 'validation-failed') {
        this.validationService.connectErrorsToForm(this.form, event.data);
      }
    });
  }

  get f() {
    return this.form.controls;
  }

  captchaResolved(isResolved: boolean): void {
    this.isCaptchaVerified = isResolved;
  }

  onSubmit() {
    this.submitted = true;

    this.loading = true;
    this.api.passwordForgot(this.f.email.value).subscribe(
      () => {
        this.notification.success('Success', 'Password reset email sent.');
        this.loading = false;
        this.router.navigate(['/auth/login']);
      },
      (err) => {
        this.notification.error('Error', 'Failed to send password reset email.');
        this.loading = false;
      }
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
